var map = {
	"./6pm.com.png": [
		261,
		261
	],
	"./alibaba.com.png": [
		9652,
		9652
	],
	"./aliexpress.com.png": [
		3105,
		3105
	],
	"./amazon.com.png": [
		8738,
		8738
	],
	"./asos.com.png": [
		3124,
		3124
	],
	"./bhphotovideo.com.png": [
		4468,
		4468
	],
	"./bidz.com.png": [
		3638,
		3638
	],
	"./boxycharm.com.png": [
		6413,
		6413
	],
	"./carters.com.png": [
		4533,
		4533
	],
	"./childrensplace.com.png": [
		6796,
		6796
	],
	"./ebay.com.png": [
		9274,
		9274
	],
	"./forever21.com.png": [
		4729,
		4729
	],
	"./gap.com.png": [
		156,
		156
	],
	"./hepsiburada.com.png": [
		1047,
		1047
	],
	"./hm.com.png": [
		8448,
		8448
	],
	"./ikea.com.png": [
		1104,
		1104
	],
	"./ipsy.com.png": [
		245,
		245
	],
	"./jd.com.png": [
		2964,
		2964
	],
	"./massimodutti.com.png": [
		5691,
		5691
	],
	"./myhabit.com.png": [
		7802,
		7802
	],
	"./nordstrom.com.png": [
		2211,
		2211
	],
	"./oldnavy.com.png": [
		3432,
		3432
	],
	"./oldnavy.gap.com.png": [
		3817,
		3817
	],
	"./pandabuy.com.png": [
		6274,
		6274
	],
	"./pinbaba.com.png": [
		9767,
		9767
	],
	"./public.gr.png": [
		3146,
		3146
	],
	"./rockauto.com.png": [
		2580,
		2580
	],
	"./shein.com.png": [
		1381,
		1381
	],
	"./superbuy.com.png": [
		2060,
		2060
	],
	"./taobao.com.png": [
		4775,
		4775
	],
	"./trendyol.com.png": [
		9764,
		9764
	],
	"./urbanog.com.png": [
		6047,
		6047
	],
	"./urbanoutfitters.com.png": [
		8176,
		8383
	],
	"./victoriassecret.com.png": [
		700,
		700
	],
	"./walmart.com.png": [
		8601,
		8601
	],
	"./wish.com.png": [
		7610,
		7610
	],
	"./yoox.com.png": [
		1778,
		1778
	],
	"./zappos.com.png": [
		4379,
		4379
	],
	"./zara.com.png": [
		1491,
		1491
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1670;
module.exports = webpackAsyncContext;